const styles = theme => ({
    background: {
        background: '#180D2B',
        display: "flex",
        width: '100%',
        height: '100%',
        flexShrink: 0,
    }
})

export default styles
